import './LoadingScreen.css'; // You can use inline styling as well, but for clean structure, use a CSS file.

const LoadingScreen = () => {
    return (
        <div className="splash-screen">
            <div className="splash-logo">
                <img src="https://campabeveragesadmin.ril.com/uploads/Campa_Logo_2380bb59ca.svg" alt="Logo" />
            </div>
        </div>
    );
};

export default LoadingScreen;